<template>
  <section class="h-100">

    <div style="padding: 40px;">
      <div class="m-auto" style="display: inline-block;">
        <img
          src="@/assets/images/relatus_green_logo_horizontal.svg"
        >
      </div>

      <div style="display: inline-block;float: right;margin-top: 13px;">
        <span class="uppercase">Pre-register</span>
        <img
          src="@/assets/images/menu.svg"
          style="display: inline-block;margin-left: 20px;"
        >
      </div>
    </div>

    <div class="flex h-screen"  style="height:80vh;">
      <div class="m-auto">

        <img
          src="@/assets/images/relatus_green_logo.svg"
          class="m-auto"
          style="height: 100px;"
        >

        <div style="margin-top: 30px;">
          <h3 class="text text-center">
            You’ve selected the Pro Plan
          </h3>

          <p class="text text-center">
            Please confirm your personal details in the fields below
          </p>

          <p class="mt-10">
            <input type="checkbox" /> I agree to the Relatus platform and Service Terms and Conditions.
          </p>
        </div>

        <div class="mt-7 text-center">
          <div class="inline">
            <router-link
              :to="{name: 'registration.plans'}"
              class="btn btn-white align-self-center me-auto mt-8 mr-3"
              style="color: #83C03B!important;border-color: #83C03B!important;"
            >
              Change Plan
            </router-link>
          </div>

          <div class="inline">
            <stripe-checkout
              ref="checkoutRef"
              mode="subscription"
              :pk="publishableKey"
              :line-items="lineItems"
              :success-url="successURL"
              :cancel-url="cancelURL"
              @loading="v => loading = v"
            />

            <button
              class="btn btn-primary align-self-center me-auto mt-8"
              style="background-color: #83C03B!important;border-color: #83C03B!important;"
              @click="submit"
            >
              Pay Now
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { StripeCheckout } from '@vue-stripe/vue-stripe';

export default {
  name: 'PlanSelected',
  data() {
    this.publishableKey = "pk_test_51K2f89AQURdHvwRvaeeKq8CSyjTQw35GuClZjvqwcRTNnNRjPRXO251ohb4yeGISKHq9hOQn1DJHKdj0QWKQI0OT00ZWjvLBBB";
    return {
      selectedPlan: null,
      loading: false,
      lineItems: [
        {
          price: 'price_1K4pdeAQURdHvwRv87baSGkz',
          quantity: 1
        },
      ],
      // successURL: 'http://localhost:8081/registration/payment/success',
      // cancelURL: 'http://localhost:8081/registration/plans',
      successURL: 'https://qa.profile.relatus.com/registration/payment/success',
      cancelURL: 'https://qa.profile.relatus.com/registration/plans',
    };
  },
  methods: {
    selectPlan: function(plan) {
      this.selectedPlan = plan;
    },
    submit () {
      this.$refs.checkoutRef.redirectToCheckout();
    }
  },
  components: {
    StripeCheckout,
  }
}
</script>

<style scoped>
h3 {
  font-family: 'Helvetica';
  font-size: 30px;
  line-height: 40px;
  color: #1E1E1E;
  letter-spacing: 1px;
  font-weight: 700;
}
.sign-up p {
  font-family: 'Helvetica';
  font-size: 24px;
  line-height: 30px;
  color: #1E1E1E;
  margin-bottom: 0;
  font-weight: 300;
}
.sign-up .social-links {
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
  border-radius: 45px;
  padding: 10px;
  min-height: 50px;
}
.sign-up .social-links img {
  height: 24px;
}

/* FIX: Input must be a component */
.btn-primary {
  background-color: #FF6600;
  color: #FFFFFF;
  padding: 10px;
  border: 1px solid #FF6600;
  box-sizing: border-box;
  border-radius: 35px;
}
.alert-error {
  background: rgba(217, 54, 31, 0.3);
  border-radius: 10px;
  padding: 10px;
}
.alert-error p {
  font-size: 14px;
}
a.btn-white {
  background-color: transparent;
  color: #FFFFFF;
  padding: 10px;
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  border-radius: 35px;
}
</style>
